export default "__VITE_ASSET__Dm0V5e2H__"